import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { helper } from 'utils';
import ExternalService from 'components/Checkout/external.service';
import { useApp } from 'context/AppContext';
import { Goods, Loader, Status } from 'components';
import { Button } from 'styles/AppStyles';
import { Container, GoodsContainer, Text } from './Styles';
import { currentGameConfig } from 'utils/handleCurrentContentConfig';

const statuses = {
  O: 'pending',
  S: 'success',
  F: 'error',
};

const Invoice = () => {
  const navigate = useNavigate();
  const { setGlobalError } = useApp();
  const { iId } = useParams();

  let timeoutId;
  const { redirector } = currentGameConfig;

  const [invoice, setInvoice] = useState();
  const status = statuses[invoice?.iSs];

  const getInvoiceStatus = async () => {
    const [invoiceData, error] = await helper.asyncWrapper(() => ExternalService.getInvoiceStatus({ iId }));
    const { sts, iSs } = invoiceData;

    if (error || sts !== 's') {
      setGlobalError(true);
      return;
    }

    setInvoice(invoiceData);

    if (timeoutId) {
      clearTimeout(timeoutId);
    } else if (statuses[iSs] === 'pending') {
      timeoutId = setTimeout(() => getInvoiceStatus(), 3000);
    }
  };

  useEffect(() => {
    getInvoiceStatus();
    return () => clearTimeout(timeoutId);
  }, []);

  const InvoiceStatus = () => {
    switch (status) {
      case 'pending':
        return (
          <>
            <Text>Your purchase is being processed...</Text>
            <Loader />
          </>
        );
      case 'success':
        return (
          <>
            <Text>Claim your goods in the app</Text>
            <GoodsContainer>
              <Goods goods={invoice.gLt} />
            </GoodsContainer>
            <Button onClick={() => window.open(redirector)}>Open App</Button>
          </>
        );
      case 'error':
        return (
          <>
            <Text>We were unable to process your purchase, try again or contact our support team.</Text>
            <Button onClick={() => navigate('/', { replace: true })}>Back to Store</Button>
          </>
        );
    }
  };

  return invoice ? (
    <Container>
      <Status type={status} />
      <InvoiceStatus />
    </Container>
  ) : (
    <Loader fullHeight />
  );
};

export default Invoice;
